import { CARD_STYLED_PROPS } from './interface'
import styled from 'styled-components'
import { colors } from '../../lib/colors'
import { dealIn, flip } from './animations/animations'

export const CardWrapper = styled.div<CARD_STYLED_PROPS>`
  width: 55px;
  height: 80px;
  perspective: 500px;
  transform-style: preserve-3d;
  transition: all 0.25s;
  transition-timing-function: cubic-bezier(0.41, 0.21, 0.17, 0.79);

  ${({ flipCard }) => flipCard && flip};
  opacity: ${({ dealOut }) => (dealOut ? 0 : 1)};
  transition-delay: ${({ delay }) => delay + 'ms'};
`

export const CardFrontWrapper = styled.div<CARD_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  border-radius: 8px;
  background-color: ${({ background, fold }) =>
    fold ? colors.cardWhite : background};
  transition: background-color 0.4s;
  /* transition-delay: 0.5s; */
  padding-top: 14px;
  transform: ${({ flipCard }) =>
    flipCard
      ? 'translate(0, 0) rotate(0)'
      : 'translate(320px, -600px) rotate(-180deg)'};
  ${({ deal }) => deal && dealIn};
  animation-delay: ${({ animDelay }) => animDelay + 's'};

  p {
    line-height: 24px;
    font-size: 24px;
    color: ${({ suitColor }) => suitColor};
  }
  svg {
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 12px;
    width: 24px;
    height: 22px;
    path {
      fill: ${({ suitColor }) => suitColor};
    }
  }
`

export const Cardback = styled.div<CARD_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  border-radius: 8px;
  background-color: ${colors.cardBack};
  transform: rotateY(180deg);
  ${({ deal, flipCard }) => deal && !flipCard && dealIn};
  animation-delay: ${({ animDelay }) => animDelay + 's'};
`
